var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useState } from "react";
import { addIndex, equals, forEach } from "ramda";
import styled from "styled-components";
import Button from "components/button";
import Input from "components/input";
import { RequestStatus } from "types/requests";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
var StyledGrid = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr 120px 6.5rem;\n  grid-template-areas: \"card-number pin-number button\";\n  grid-column-gap: 0;\n  width: 100%;\n\n  div {\n    grid-area: pin-number;\n  }\n\n  div:first-child {\n    grid-area: card-number;\n  }\n\n  .text-input,\n  .applied-code {\n    padding-right: 1rem;\n    max-height: 33px;\n  }\n\n  button {\n    grid-area: button;\n    width: 100%;\n    line-height: 100%;\n  }\n  @media (max-width: 1024px) {\n    row-gap: 13px;\n    grid-template-columns: 7.5rem 6.5rem 1fr;\n    grid-template-areas:\n      \"card-number card-number card-number\"\n      \"pin-number button .\";\n\n    button {\n      align-self: flex-end;\n      line-height: 150%;\n      max-height: 36.38px;\n    }\n    .text-input,\n    .applied-code {\n      max-height: 37px;\n    }\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 120px 6.5rem;\n  grid-template-areas: \"card-number pin-number button\";\n  grid-column-gap: 0;\n  width: 100%;\n\n  div {\n    grid-area: pin-number;\n  }\n\n  div:first-child {\n    grid-area: card-number;\n  }\n\n  .text-input,\n  .applied-code {\n    padding-right: 1rem;\n    max-height: 33px;\n  }\n\n  button {\n    grid-area: button;\n    width: 100%;\n    line-height: 100%;\n  }\n  @media (max-width: 1024px) {\n    row-gap: 13px;\n    grid-template-columns: 7.5rem 6.5rem 1fr;\n    grid-template-areas:\n      \"card-number card-number card-number\"\n      \"pin-number button .\";\n\n    button {\n      align-self: flex-end;\n      line-height: 150%;\n      max-height: 36.38px;\n    }\n    .text-input,\n    .applied-code {\n      max-height: 37px;\n    }\n  }\n"])));
var StyledFlex = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n\n  @media (max-width: 1024px) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n"], ["\n  display: flex;\n\n  @media (max-width: 1024px) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n"])));
function GiftCardRow(_a) {
    var applyGiftCard = _a.applyGiftCard, removeGiftCard = _a.removeGiftCard, giftCard = _a.giftCard, giftCardStatus = _a.giftCardStatus, giftCards = _a.giftCards, _b = _a.flags, flags = _b === void 0 ? {} : _b;
    var _c = useState(giftCard), giftCardObject = _c[0], setGiftCardObject = _c[1];
    var formatGiftCardNumber = function (val) {
        var newVal = "";
        var foreachIndexed = addIndex(forEach);
        foreachIndexed(function (value, idx) {
            if ((val.length - idx) % 4 === 0 && idx > 0)
                newVal = newVal.concat("-");
            newVal = newVal.concat(value);
        }, val);
        return newVal;
    };
    useEffect(function () {
        var newGiftCardNumber = giftCard.giftCardNumber;
        if (!/-/g.test(giftCard.giftCardNumber)) {
            newGiftCardNumber = formatGiftCardNumber(giftCard.giftCardNumber);
        }
        setGiftCardObject(__assign(__assign({}, giftCard), { giftCardNumber: newGiftCardNumber }));
    }, [giftCard]);
    var removeDashes = function (input) {
        return input.replace(/-/g, "");
    };
    var apply = useCallback(function () {
        var newGiftCard = __assign(__assign({}, giftCardObject), { giftCardNumber: removeDashes(giftCardObject.giftCardNumber) });
        applyGiftCard(newGiftCard, flags);
    }, [applyGiftCard, giftCardObject]);
    var remove = useCallback(function () {
        removeGiftCard(giftCardObject.index, flags);
    }, [removeGiftCard, giftCardObject]);
    var updateGiftCard = function (event) {
        var _a;
        var propName = event.target.name;
        var newVal = event.target.value;
        var re = /^[\d\-\b]+$/;
        var val = removeDashes(event.target.value);
        if (event.target.value === "" || re.test(event.target.value)) {
            if (equals(propName, "giftCardNumber")) {
                newVal = formatGiftCardNumber(val);
            }
            setGiftCardObject(__assign(__assign({}, giftCardObject), (_a = {}, _a[propName] = newVal, _a)));
        }
    };
    var isApplied = function (giftCardCheck) {
        return giftCards.some(function (giftCardItem) {
            return equals(giftCardItem.giftCardNumber, removeDashes(giftCardCheck.giftCardNumber)) &&
                equals(giftCardItem.pin, giftCardCheck.pin) &&
                equals(giftCardItem.index, giftCardCheck.index);
        });
    };
    var isFailed = function (giftCardCheck) {
        return (!isApplied(giftCardCheck) && equals(giftCardStatus, RequestStatus.FAILURE));
    };
    var isDuplicate = function (giftCardCheck) {
        return giftCards.some(function (giftCardItem) {
            return equals(giftCardItem.giftCardNumber, removeDashes(giftCardCheck.giftCardNumber)) && !equals(giftCardItem.index, giftCardCheck.index);
        });
    };
    var handleErrors = function (giftCardCheck) {
        if (isFailed(giftCardCheck)) {
            return "The card entered is not valid";
        }
        if (isDuplicate(giftCardCheck)) {
            return "The card you entered is already applied";
        }
        return "";
    };
    return (React.createElement("div", { className: "row" },
        React.createElement(StyledGrid, null,
            React.createElement(StyledFlex, null,
                React.createElement("label", { htmlFor: "gift-card-number" + giftCardObject.index, className: "shrink" }, "Card Number"),
                " ",
                React.createElement(Input, { disabled: isApplied(giftCardObject), error: handleErrors(giftCardObject), id: "gift-card-number" + giftCardObject.index, name: "giftCardNumber", type: "tel", onChange: function (e) { return updateGiftCard(e); }, value: giftCardObject.giftCardNumber })),
            React.createElement(StyledFlex, null,
                React.createElement("label", { htmlFor: "gift-card-pin" + giftCardObject.index, className: "shrink" }, "PIN"),
                " ",
                React.createElement(Input, { disabled: isApplied(giftCardObject), error: isFailed(giftCardObject) || isDuplicate(giftCardObject) ? " " : "", id: "gift-card-pin" + giftCardObject.index, name: "pin", onChange: function (e) { return updateGiftCard(e); }, type: "tel", value: giftCardObject.pin })),
            isApplied(giftCardObject) ? (React.createElement(Button, { type: "secondary", className: "caps", onClick: remove }, "Remove")) : (React.createElement(Button, { type: "primary", className: "caps", onClick: apply, disabled: !giftCardObject.giftCardNumber ||
                    !giftCardObject.pin ||
                    isDuplicate(giftCardObject) }, "Apply")))));
}
export default withLDConsumer()(GiftCardRow);
var templateObject_1, templateObject_2;
